/* eslint-disable no-undef */
export const raiseAnalyticsTracking = (eventType, data) => {
  if (window.eventListenerFrameworkLoaded) {
    const event = new CustomEvent(eventType, { detail: data });
    document.dispatchEvent(event);
  } else {
    document.addEventListener("framework-script-loaded", () => {
      const event = new CustomEvent(eventType, { detail: data });
      document.dispatchEvent(event);
    });
  }
};

export const genericPageAdobeLog = ({
  status,
  userId,
  onVideoData,
  onAudioData,
  onContClickData,
  onCustomLinkContClickData,
  customLinkData,
  pageData,
  loginData,
  adobePushTracking,
  subcriptionData,
  searchOnLoad,
  paginationTrack, feedbackTrack, searchNoResults, subscriptionStatus

}) => {
  if (
    status === "screenload"
  ) {
    raiseAnalyticsTracking("pmi-reset-tracking");

  }
  if (
    status === "pageload"
  ) {

    raiseAnalyticsTracking("pmi-reset-tracking");
  }

  if (onVideoData) {
    raiseAnalyticsTracking("pmi-add-tracking", onVideoData);
  }

  if (onAudioData) {
    raiseAnalyticsTracking("pmi-add-tracking", onAudioData);
  }

  if (onContClickData) {
    raiseAnalyticsTracking("pmi-add-tracking", onContClickData);
  }

  if (onCustomLinkContClickData) {
    raiseAnalyticsTracking("pmi-add-tracking", onCustomLinkContClickData);
  }

  if (customLinkData) {
    raiseAnalyticsTracking("pmi-add-tracking", customLinkData);
  }

  // if (pageData) {
  //   raiseAnalyticsTracking("pmi-add-tracking", pageData);
  // }

  if (subcriptionData) {
    raiseAnalyticsTracking("pmi-add-tracking", subcriptionData);
  }

  if (searchOnLoad) {
    raiseAnalyticsTracking("pmi-add-tracking", searchOnLoad);
  }
  if (searchNoResults) {
    raiseAnalyticsTracking("pmi-add-tracking", searchNoResults);
  }


  if (paginationTrack) {
    raiseAnalyticsTracking("pmi-add-tracking", paginationTrack);
  }

  if (feedbackTrack) {
    raiseAnalyticsTracking("pmi-add-tracking", feedbackTrack);
  }
  if (subscriptionStatus) {
    raiseAnalyticsTracking("pmi-add-tracking", subscriptionStatus);

  }
  // if (userId) {
  //   const loginData = {
  //     event: "loggedin",
  //     eventInfo: "loggedin",
  //     user: {
  //       pmiID: userId,
  //     },
  //   };
  //   const adobeDataLayerArr = window?.adobeDataLayer || []
  //   if (!(adobeDataLayerArr.filter(function (e) { return e.eventInfo === 'loggedin'; }).length > 0)) {
  //     raiseAnalyticsTracking("pmi-add-tracking", loginData);
  //   }
  // }
  if (loginData) {
    raiseAnalyticsTracking("pmi-add-tracking", loginData);
  }

  if (adobePushTracking) {
    raiseAnalyticsTracking("pmi-push-tracking");
  }
};

export const pushDatatoAdobeLayer = ({
  status,
  userId = null,
  onVideoData = null,
  onAudioData = null,
  onContClickData = null,
  onCustomLinkContClickData = null,
  customLinkData = null,
  pageData = null,
  loginData = null,
  adobePushTracking = true,
  subcriptionData = null,
  searchOnLoad = null,
  paginationTrack = null,
  feedbackTrack = null,
  searchNoResults = null,
  subscriptionStatus = null
}) => {
  genericPageAdobeLog({
    status,
    userId,
    onVideoData,
    onAudioData,
    onContClickData,
    onCustomLinkContClickData,
    customLinkData,
    pageData,
    adobePushTracking,
    loginData,
    subcriptionData,
    paginationTrack,
    searchOnLoad,
    feedbackTrack,
    searchNoResults,
    subscriptionStatus
  });
};
